import React from "react";
import dot from "../../assets/images/servicesimg.png";
import brick_logo from "../../assets/images/Brick letter logo.png";
import sarasu_logo from "../../assets/images/sarasu logo 2.png";
import img1 from "../../assets/images/Icons_and_images/009.png";
import img2 from "../../assets/images/Icons_and_images/006.png";
import img3 from "../../assets/images/Icons_and_images/008.png";
import img4 from "../../assets/images/Icons_and_images/007.png";
import img5 from "../../assets/images/Icons_and_images/005.png";
import img6 from "../../assets/images/Icons_and_images/002.png";
import img7 from "../../assets/images/Icons_and_images/003.png";
import img8 from "../../assets/images/Icons_and_images/001.png";
import img9 from "../../assets/images/Icons_and_images/004.png";
import Web_App from "../../assets/images/mobappicon.png";
import Mob_App from "../../assets/images/icon3.png";
import { Element } from "react-scroll";

const Feature = ({ icon, label }) => (
  <div
    className="d-flex align-items-center gap-2"
    style={{ fontSize: "0.8rem", color: "#563D7C", fontWeight: 600 }}
  >
    <img
      src={icon}
      alt=""
      width={16}
      style={{ flexShrink: 0, opacity: 0.85 }}
    />
    <span>{label}</span>
  </div>
);

const Card = ({ children }) => (
  <div
    className="h-100 bg-white rounded-3 p-4"
    style={{
      border: "1px solid rgba(86,61,124,0.1)",
      boxShadow: "0 2px 16px rgba(86,61,124,0.06)",
      transition: "box-shadow 0.2s, transform 0.2s",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.boxShadow = "0 8px 32px rgba(86,61,124,0.13)";
      e.currentTarget.style.transform = "translateY(-3px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.boxShadow = "0 2px 16px rgba(86,61,124,0.06)";
      e.currentTarget.style.transform = "translateY(0)";
    }}
  >
    {children}
  </div>
);

const CardHeader = ({ logo, logoWidth, title }) => (
  <div
    className="d-flex align-items-center gap-3 mb-3 pb-3"
    style={{ borderBottom: "1px solid rgba(86,61,124,0.08)" }}
  >
    <img
      src={logo}
      alt={title}
      style={{
        width: logoWidth,
        height: "auto",
        objectFit: "contain",
        flexShrink: 0,
      }}
    />
    <h5
      className="mb-0"
      style={{
        color: "#563D7C",
        fontWeight: 700,
        fontSize: "1rem",
        lineHeight: 1.3,
      }}
    >
      {title}
    </h5>
  </div>
);

function Solutions() {
  return (
    <Element name="Advantages">
      {/* Cards grid */}
      <div
        className="py-5"
        style={{
          backgroundImage: `url(${dot})`,
          backgroundSize: "1000px",
          backgroundPosition: "bottom",
          backgroundColor: "#f8f9fb ",
        }}
      >
        {/* Section heading */}
        <div className="text-center py-4 px-3">
          <p
            className="mb-1"
            style={{
              fontSize: "0.72rem",
              fontWeight: 700,
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "#563D7C",
            }}
          >
            Why choose us
          </p>
          <h2
            className="text-uppercase mb-0"
            style={{
              fontWeight: 800,
              letterSpacing: "0.03em",
              color: "#1a1a2e",
            }}
          >
            The Athees Info Advantages
          </h2>
          <div
            style={{
              width: 48,
              height: 3,
              background: "#563D7C",
              borderRadius: 2,
              margin: "0.75rem auto 0",
              opacity: 0.6,
            }}
          />
        </div>
        <div className="container" style={{ maxWidth: 1100 }}>
          <div className="row g-4">
            {/* ── Brick ── */}
            <div className="col-12 col-md-6">
              <Card>
                <CardHeader
                  logo={brick_logo}
                  logoWidth="30%"
                  title="Construction Management"
                />
                <p
                  className="mb-3"
                  style={{
                    fontSize: "0.875rem",
                    color: "#444",
                    lineHeight: 1.7,
                  }}
                >
                  Empower Your Team and Take Control with Our Cutting Edge
                  Construction Management Application!
                </p>
                <ol
                  className="mb-3 ps-3"
                  style={{
                    fontSize: "0.825rem",
                    color: "#444",
                    lineHeight: 1.9,
                  }}
                >
                  <li>Data-Driven Decision Making</li>
                  <li>Enhanced Communication and Collaboration</li>
                  <li>Early and Effective cost and Risk Management</li>
                </ol>
                <div className="row row-cols-2 g-2 mt-1">
                  {[
                    { icon: img1, label: "Structures based item of work" },
                    { icon: img2, label: "Chainage mapping" },
                    { icon: img3, label: "Material management" },
                    { icon: img1, label: "Monitoring" },
                    { icon: img4, label: "Human resource management" },
                    { icon: img5, label: "Billing" },
                  ].map(({ icon, label }) => (
                    <div key={label} className="col">
                      <Feature icon={icon} label={label} />
                    </div>
                  ))}
                </div>
              </Card>
            </div>

            {/* ── Sarasu ── */}
            <div className="col-12 col-md-6">
              <Card>
                <CardHeader
                  logo={sarasu_logo}
                  logoWidth="32%"
                  title="Online Testing Practice"
                />
                <p
                  className="mb-3"
                  style={{
                    fontSize: "0.875rem",
                    color: "#444",
                    lineHeight: 1.7,
                  }}
                >
                  We provide customized disciplined testing practice align with
                  the school time schedule for Physics, Chemistry &amp; Biology.
                  SARASU NEET Online Testing Practice software has a wide-range
                  of test practice, evaluation and training management platform
                  that helps students to excel the accuracy, speed and tackle
                  difficult indirect question at ease.
                </p>
                <div className="row row-cols-2 g-2 mt-1">
                  {[
                    { icon: img6, label: "Testing practice" },
                    { icon: img7, label: "Partnering with schools" },
                    { icon: img8, label: "Capability analysis reports" },
                    { icon: img9, label: "AI formulates test schedules" },
                  ].map(({ icon, label }) => (
                    <div key={label} className="col">
                      <Feature icon={icon} label={label} />
                    </div>
                  ))}
                </div>
              </Card>
            </div>

            {/* ── Web App ── */}
            <div className="col-12 col-md-6">
              <Card>
                <CardHeader
                  logo={Mob_App}
                  logoWidth="14%"
                  title="Web Application"
                />
                <p
                  className="mb-0"
                  style={{
                    fontSize: "0.875rem",
                    color: "#444",
                    lineHeight: 1.7,
                  }}
                >
                  We are Affordable Enterprise app Development Company. Our team
                  is proficient to ideate and launching web portals and custom
                  built-websites. They have in-depth knowledge of various
                  technology like Java, Spring, MERN stack, MEAN Stack,
                  Fullstack, Python, Django.
                </p>
              </Card>
            </div>

            {/* ── Mobile App ── */}
            <div className="col-12 col-md-6">
              <Card>
                <CardHeader
                  logo={Web_App}
                  logoWidth="16%"
                  title="Mobile Application"
                />
                <p
                  className="mb-0"
                  style={{
                    fontSize: "0.875rem",
                    color: "#444",
                    lineHeight: 1.7,
                  }}
                >
                  We provide a wide range of services for all kinds of
                  businesses. You can leverage your brand idea with our mobile
                  app development services. The tailor-made &amp; customized
                  solutions that we offer are built to target your unique
                  business model. Our techstack includes hybrid of React Native,
                  Flutter and Native app development iOS &amp; Android.
                </p>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </Element>
  );
}

export default Solutions;
